import React from 'react';
import cn from 'classnames';
import Modal from '../../Modal/Modal';
import Navigation from '../index';
import { useModalOpen } from './hooks';
import styles from './NavigationModal.module.css';

const NavigationModal = ({ className }) => {
  const isOpen = useModalOpen();

  return (
    <Modal
      isOpen={isOpen}
      className={cn(styles.modal, styles.scrollbar)}
      overlayClassName={cn(styles.overlay, className)}
    >
      <Navigation />
    </Modal>
  );
};

export default NavigationModal;
